import { render, staticRenderFns } from "./tabbar-life.vue?vue&type=template&id=a0b0d100&scoped=true"
import script from "./tabbar-life.vue?vue&type=script&lang=js"
export * from "./tabbar-life.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b0d100",
  null
  
)

export default component.exports